<template>
  <div class="settings-container">
    <div class="settings-header">
      <span class="back" @click="$router.push('/profile')">&#8592;</span>
      <span class="title">设置中心</span>
    </div>
    <div class="settings-list">
      <div class="settings-group">
        <div class="settings-group-title">账户设置</div>
        <div class="settings-item" @click="editProfile">
          <span class="settings-item-icon">👤</span>
          <span class="settings-item-label">个人信息</span>
          <span class="settings-item-arrow">&#8250;</span>
        </div>
        <div class="settings-item" @click="changePassword">
          <span class="settings-item-icon">🔒</span>
          <span class="settings-item-label">修改密码</span>
          <span class="settings-item-arrow">&#8250;</span>
        </div>
        <div class="settings-item" @click="bindPhone">
          <span class="settings-item-icon">📱</span>
          <span class="settings-item-label">绑定手机</span>
          <span class="settings-item-arrow">&#8250;</span>
        </div>
      </div>
      <div class="settings-group">
        <div class="settings-group-title">其他</div>
        <div class="settings-item" @click="logout">
          <span class="settings-item-icon">🚪</span>
          <span class="settings-item-label">退出登录</span>
          <span class="settings-item-arrow">&#8250;</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SettingsPage',
  data () {
    return {
    }
  },
  methods: {
    ...mapActions(['Logout']),
    editProfile () { this.$router.push('/user-profile') },
    changePassword () { this.$router.push('/change-password') },
    bindPhone () { this.$router.push('/bind-phone') },
    async logout () {
      if (confirm('确定要退出登录吗？')) {
        // 清除用户缓存（包括token、userInfo、登录凭证过期时间等）
        await this.Logout()
        // 清除userId缓存
        localStorage.removeItem('userId')
        // 跳转到登录页
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.settings-container {
  width: 100vw;
  max-width: 430px;
  min-height: 100vh;
  background: #f7f8fa;
  margin: 0 auto;
  box-sizing: border-box;
  padding-bottom: 80px;
}

.settings-header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
  font-size: 20px;
  font-weight: bold;
}

.settings-header .back {
  position: absolute;
  left: 0;
  height: 56px;
  display: flex;
  align-items: center;
  font-size: 26px;
  padding-left: 16px;
  cursor: pointer;
}

.settings-list {
  margin: 18px 0 0;
}

.settings-group {
  margin-bottom: 24px;
}

.settings-group-title {
  font-size: 16px;
  font-weight: 500;
  color: #888;
  margin: 0 16px 8px;
  padding-left: 4px;
}

.settings-item {
  background: #fff;
  border-radius: 12px;
  margin: 0 16px 8px;
  padding: 16px 18px;
  box-shadow: 0 2px 8px #e0e0e033;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
}

.settings-item:active {
  background: #f7f8fa;
  transform: scale(0.98);
}

.settings-item-icon {
  font-size: 24px;
  margin-right: 12px;
  width: 24px;
  text-align: center;
}

.settings-item-label {
  flex: 1;
  font-size: 17px;
  color: #222;
  font-weight: 500;
}

.settings-item-arrow {
  font-size: 20px;
  color: #bbb;
  margin-left: 8px;
}

.settings-item-switch {
  width: 44px;
  height: 24px;
  background: #ddd;
  border-radius: 12px;
  position: relative;
  transition: background 0.2s;
  margin-left: 8px;
}

.settings-item-switch::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.settings-item-switch.active {
  background: #3572e6;
}

.settings-item-switch.active::after {
  transform: translateX(20px);
}
</style>
